import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import PropTypes from "prop-types";

import { t } from "@/i18n-js/instance";
import { anchorClassNames } from "@/react/helpers/cssAnchorHelpers";

import { ActionButton } from "./ActionButton";
import { LikeCounter } from "./LikeCounter";

export const EngagementActions = ({
  canLike,
  canReply,
  canSeeLikes,
  isLiked,
  isLikeDisabled,
  likesCount,
  onLikeClick,
  onLikesCountClick,
  onReplyClick,
}) => {
  const { currentUser } = usePunditUserContext();

  /*
    We display the likes count based on the following scenarios -
      - Display likes count if and only if canSeeLikes is true, likesCount is greater than 0, and,
      - Display likes count if a user is logged in or if the user can like or reply to the post.
      - The reason for the second condition is that for communities that allow members to sign up we render
        the like/comment button for non logged -n users(we redirect them to the login page) and
        hence we can show the likes count as well.
  */
  const shouldShowLikesCount =
    canSeeLikes && likesCount > 0 && (currentUser || (canLike && canReply));

  return (
    <div
      className={classNames(
        anchorClassNames("post__actions post__actions-visible"),
        "mt-1 flex pl-[3.25rem]",
      )}
    >
      {canLike && (
        <ActionButton
          className={classNames(
            anchorClassNames("post__actions--like", {
              liked: isLiked,
            }),
            "mr-2",
          )}
          label={t(`comments.engagement_actions.${isLiked ? "liked" : "like"}`)}
          onClick={onLikeClick}
          disabled={isLikeDisabled}
          isLiked={isLiked}
        />
      )}
      {canReply && (
        <ActionButton
          className={anchorClassNames("post__actions--reply")}
          label={t("comments.engagement_actions.reply")}
          onClick={onReplyClick}
        />
      )}
      {shouldShowLikesCount && (
        <LikeCounter likesCount={likesCount} onClick={onLikesCountClick} />
      )}
    </div>
  );
};

EngagementActions.propTypes = {
  canLike: PropTypes.bool.isRequired,
  canReply: PropTypes.bool.isRequired,
  canSeeLikes: PropTypes.bool.isRequired,
  isLiked: PropTypes.bool.isRequired,
  isLikeDisabled: PropTypes.bool.isRequired,
  likesCount: PropTypes.number.isRequired,
  onLikeClick: PropTypes.func.isRequired,
  onLikesCountClick: PropTypes.func.isRequired,
  onReplyClick: PropTypes.func.isRequired,
};
